import { render, staticRenderFns } from "./ProduitQualiforma.vue?vue&type=template&id=82372a94&"
import script from "./ProduitQualiforma.vue?vue&type=script&lang=js&"
export * from "./ProduitQualiforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports